import axios from "axios";
import authHeader from '../../../authheader'

const EIAPPLICATIONURL = process.env.REACT_APP_APIURL + "/api/IndividualEiApplication";

const getRecommendations = (applicationId) => {
    return axios.get(`${EIAPPLICATIONURL}/recommendations`, { headers: authHeader(), params: { applicationId } });
}
const postRecommendation = (data) => {
    return axios.post(`${EIAPPLICATIONURL}/recommendation`, data, { headers: authHeader() });
}

const sendRecommendationEmail = (recommendationId) => {
    return axios.post(`${EIAPPLICATIONURL}/sendrecommendationemail`, null, { headers: authHeader(), params: { recommendationId } });
}

export default {
    getRecommendations,
    postRecommendation,
    sendRecommendationEmail
}